// TODO: Add more locales as they are supported by the remote config
export type SupportedLocale = 'en-AU' | 'de-DE'

export interface SupportedLocaleOption {
  locale: SupportedLocale
  /** Language name in its native language */
  nativeName: string
}

export const SUPPORTED_LOCALE_OPTIONS: Array<SupportedLocaleOption> = [
  {
    locale: 'en-AU',
    nativeName: 'English',
  },
  {
    locale: 'de-DE',
    nativeName: 'Deutsch',
  },
]
